import React, { Component } from 'react'
import ReactSpeedometer from 'react-d3-speedometer'

import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
    speedometer: {
        [theme.breakpoints.down('xs')]: {
            marginLeft: '-1vw'
        }
    }
})

class Speedometer extends Component {

    constructor(props){
        super(props) 
    }
     
    parseJSON(){
        var SpeedometerFriendlyJSON = {}
        var currentJSON = this.props.content;
        var obj = {'text': '', position: 'OUTSIDE', color:'fff', key: ''}
        var customLabels = []
        var segmentColors = []
        var segmentBreakpoints = [0]
        var maxValue = 0
        Object.keys(currentJSON.Segments).forEach(k => {
            obj.text = currentJSON.Segments[k].Label;
            obj.key = k;
            customLabels.push({'text':currentJSON.Segments[k].Label, "position": "OUTSIDE", 'color':'000'})
            segmentColors.push(currentJSON.Segments[k].Color)
            segmentBreakpoints.push(parseInt(currentJSON.Segments[k].UpperBounds))
            maxValue=parseInt(currentJSON.Segments[k].UpperBounds)
        })
        SpeedometerFriendlyJSON.labels = customLabels
        SpeedometerFriendlyJSON.colors = segmentColors
        SpeedometerFriendlyJSON.breakpoints = segmentBreakpoints
        SpeedometerFriendlyJSON.maxValue = maxValue
        /* segmentColors={["#9399ff", "#14ffec", "#00bbf0"]}
                            currentValueText="How are you?"
                            customSegmentLabels={[
                              {
                                text: "Good",
                                position: "OUTSIDE",
                                color: "#fff",
                              },
                              {
                                text: "Great",
                                position: "OUTSIDE",
                                color: "#d8dee9",
                              },
                              {
                                text: "Awesome!",
                                position: "OUTSIDE",
                                color: "#d8dee9",
                              },
                            ]} */
                            console.log(SpeedometerFriendlyJSON)
        return SpeedometerFriendlyJSON;
    }
    render() {

        const {classes} = this.props
        if(this.props.type == "SEGMENT"){
            var newJSON = this.parseJSON()
            //customSegmentLabels={newJSON.labels}
            return (
                <div style={{maxHeight:'205px'}} id="speedometer">
                    <ReactSpeedometer
                            needleHeightRatio={0.7}
                            labelFontSize={"16px"}
                            width={260}
                            value={100-parseInt(this.props.score)}
                            customSegmentStops={newJSON.breakpoints}
                            segmentColors={newJSON.colors}
                            maxSegmentLabels={0}
                            paddingHorizontal={10}
                            paddingVertical={50}
                            minValue={0}
                            maxValue={100}
                            needleTransitionDuration={2500}
                            needleColor={"#000"}
                            currentValueText=" "
                          />
                </div>
                
            )
        } else {
            //why not style? because it has to use the width to render the segments.  has to be determined before display
            let width = window.screen.width <= 350 ? 240 : 260;
            return(
                <div id="speedometer" className={classes.speedometer}>
                    
                    <img src="speedometer2.png" style={{marginBottom:'-145px'}}></img>
                    <ReactSpeedometer
                    height={160}
                    needleHeightRatio={0.7}
                    maxSegmentLabels={0}
                    minValue={-3}
                    maxValue={103}
                    segments={1}
                    width={width}
                    value={100-this.props.score}
                    startColor="#ffffff00"
                    endColor="red"
                    needleColor="black"
                    currentValueText=" "
                    needleTransitionDuration={2500}
                />
                </div>
                
            )
        }
    }
}

export default withStyles(styles)(Speedometer);

